export const environment = {
  production: true,
  baseHref: "/",
  apiURL: "/api",
  apiURLMX: "/api/mx-be",
  apiURLBR: "/api/br-be",
  platformId: "latam",
  applicationURL: "https://siila.com",
  applicationURLBr: "https://siila.com.br",
  applicationURLMx: "https://siila.com.mx",
  googleTrackingID: "G-49TBDG0YJ1",
  ws: "wss://44i6e0stm6.execute-api.sa-east-1.amazonaws.com/prod",
  serverURL: "https://app.siila.com.br",
  redirectURLmx: "https://app.siila.com.mx/#!/",
  redirectURL: "https://app.siila.com.br/#!/",
  spotURL: "https://spot.siila.com.br",
  spotURLMx: "https://spot.siila.com.mx",
  listingDetailURL: "https://app.siila.com.br/#!/listing/",
  cloudfrontURL: "https://dnclcgcvl4f14.cloudfront.net/",
  googleAPIKey: "AIzaSyD7ILit-WpiTauIV0bdY2OpeSGnNfA9jXE"
};
